const networkInterfacesState = {
    lockerNetworkInterfaces: undefined,
    marketNetworkInterfaces: undefined,
    networkInterface: undefined,
    networkInterfacesAliases: undefined,
    networkingMenus: [],
    orgNetworkInterfaces: undefined,
    requestingLockerNetworkInterfaces: false,
    requestingMarketNetworkInterfaces: false,
    requestingModifyNetworkInterface: false,
    requestingNetworkInterface: false,
    requestingOrgNetworkInterfaces: false,
    requestingSiteNetworkInterfaces: false,
    siteNetworkInterfaces: undefined
};
export default networkInterfacesState;
